import * as React from "react";
import {block} from "./core";
import {Select} from "searchkit";

const map = require("lodash/map")
const identity = require("lodash/identity")

class CustomSelect extends Select {


  static defaultProps: any = {
    mod: "sk-select",
    showCount: true,
    translate:identity,
    countFormatter:identity
  }

  constructor(props){
    super(props)
    this.onChange = this.onChange.bind(this)
  }

  onChange(e){
    const { setItems } = this.props;
    const key = e.target.value;
    if (!key) {
      setItems()
    } else {
      setItems([key])
    }
  }

  getSelectedValue(){
    const { selectedItems=[] } = this.props;
    if (selectedItems.length == 0) return null;
    return selectedItems[0];
  }

  render() {
    const { mod, className, items,
      disabled, showCount, translate, countFormatter } = this.props

    const bemBlocks = {
      container: block(mod).el
    }
    return (
      <div className={bemBlocks.container().mix(className).state({ disabled }) }>
        <select onChange={this.onChange} value={this.getSelectedValue() || ""}>
          <option key={"__none"} value={""} className={"select-placeholder"} disabled={false}>{this.props.customTitle ? this.props.customTitle : window.Drupal.t("Select a Value...")}</option>
          {map(items, ({key, label, title, disabled, doc_count}) => {
            var text = window.Drupal.t(label || title || key)

            if (isNumeric(text)) {
              let num = parseFloat(text);
              text = Number(num.toFixed(2))
            }
            // Method 2: Using regex
            function isNumeric(str) {
              return /^-?\d*\.?\d+$/.test(str);
            }

            if (showCount && doc_count !== undefined) text += ` (${countFormatter(doc_count)})`
            return <option key={key} value={key} disabled={disabled}>{text}</option>
          })}
        </select>
      </div>
    )
  }
}
export default CustomSelect;



// WEBPACK FOOTER //
// ./src/CustomSelect.js